import { CheckboxValueType } from 'antd/es/checkbox/Group';

export const findCheckbox = (checkSingle: string, groupCheck: CheckboxValueType[] | string[]) => {
  return groupCheck.find((element: CheckboxValueType) => element === checkSingle);
};
